import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { PlainInput } from 'components/PlainInput'
import { SaveChanges } from 'components/SaveChanges'
import { originalAccountTypes } from 'config/user.type.constants'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { Checkbox } from 'stories/components/Checkbox/Checkbox'

interface IAccountTypesConfig {
  title: string
  visible: boolean
}

export const ManageAccountTypes = () => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState<Record<string, IAccountTypesConfig>>({})
  const [isChanged, setChanged] = useState(false)

  useEffect(() => {
    setLoading(true)
    getAdminConfig('accountTypes')
      .then(setData)
      .finally(() => setLoading(false))
  }, [])

  const onSubmit = async () => {
    setLoading(true)

    setAdminConfig('accountTypes', data)
      .then(() => {
        setChanged(false)
        toast(`Account Types Configuration has been saved.`, { type: 'info' })
      })
      .finally(() => setLoading(false))
  }

  const onChange = (key: string, value: any, map: string) => {
    let temp = cloneDeep(data) as any
    if (temp[key] === undefined) temp[key] = {}
    temp[key][map] = value
    setData(temp)
    setChanged(true)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />
      <SaveChanges show={isChanged} onSave={onSubmit} />
      <div className="mt-4">
        <table className="text-sm">
          <thead className="uppercase text-xs bg-gray-50 dark:bg-gray-700">
            <tr>
              {['No', 'Original', 'New', 'In Use'].map((v) => (
                <th scope="col" className="p-3 border" key={`header-${v}`}>
                  {v}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.keys(data).map((key, index) => {
              const { title, visible } = data[key]
              return (
                <tr key={index}>
                  <td className="p-2 border">{index + 1}</td>
                  <td className="p-2 border">{originalAccountTypes[key]}</td>
                  <td className="px-3 border">
                    <PlainInput
                      value={title}
                      content={title}
                      onChange={(value: string) => onChange(key, value, 'title')}
                    />
                  </td>
                  <td className="px-3 border text-center">
                    <Checkbox
                      color="gray"
                      id={key}
                      title={''}
                      key={key}
                      value={visible}
                      onChange={(value) => onChange(key, value, 'visible')}
                      className="w-[none]"
                    />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
